import { useEffect, useState } from "react";

const links = [
  { id: "era", label: "年代补档" },
  { id: "classics", label: "经典补档" },
  { id: "rare", label: "考古精选" },
  { id: "story", label: "读者口碑" },
  { id: "faq", label: "常见问题" },
  { id: "about", label: "关于本站" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200 shadow-soft"
          : "bg-transparent"
      }`}
    >
      <nav
        className={`mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6 transition-colors ${
          scrolled ? "text-foreground-900" : "text-background-50"
        }`}
        aria-label="主导航"
      >
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50">
            07
          </span>
          <span className="font-heading text-xl tracking-wide">
            073<span className="text-primary-600">漫画网</span>
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <li key={l.id}>
              <a
                href={`#${l.id}`}
                className="rounded-full px-3 py-2 text-sm whitespace-nowrap transition-colors hover:bg-primary-100 hover:text-primary-800"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#contribute"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            投稿补档
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            aria-expanded={open}
            className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
              scrolled ? "text-foreground-900 hover:bg-primary-100" : "text-background-50 hover:bg-white/10"
            }`}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <ul className="flex flex-col gap-1">
            {links.map((l) => (
              <li key={l.id}>
                <a
                  href={`#${l.id}`}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-2 text-foreground-900 transition-colors hover:bg-primary-100 hover:text-primary-800"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#contribute"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex w-full justify-center rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50"
              >
                投稿补档
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}